module.exports = __webpack_public_path__ + "img/carHead.162e1a8f.png";